import 'url-polyfill';

export const getJsonFromUrl = search => {
  const query = search.substr(1);
  const result = {};
  query.split('&').forEach(function(part) {
    const item = part.split('=');
    result[item[0]] = decodeURIComponent(item[1]);
  });

  return result;
};

export const getUrlFromJson = data =>
  Object.entries(data)
    .map(e => e.join('='))
    .join('&');

export const getURLParameter = key => {
  const parsedUrl = new URL(window.location.href);

  return parsedUrl.searchParams.get(key);
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js